module.exports = __webpack_public_path__ + "static/media/coverteye-1.66d2ba9b.jpg";